<template lang="html">
  <div class="about-outer">
    <svg version="1.1" id="Layer_3" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    	 width="310.29px" height="48.58px" viewBox="0 0 310.29 48.58" enable-background="new 0 0 310.29 48.58" xml:space="preserve">
    <g class="lines">
    	<path class="about-path" d="M46.574,45.993c0,0,0.338,0.911-0.737,0.911H35.132c-0.275,0-0.502-0.18-0.562-0.43l-2-8.314H16.852l-4.144,8.309
    		c-0.129,0.258-0.406,0.436-0.682,0.436H1.322c0,0-1.027,0.086-0.492-0.91l23.505-43.72c0.136-0.254,0.42-0.415,0.67-0.415h9.221
    		c0.274,0,0.496,0.184,0.558,0.414L46.574,45.993z M25.274,3.184L2.481,45.579h9.26l4.144-8.308
    		c0.129-0.259,0.406-0.436,0.682-0.436h16.64c0.267,0,0.5,0.172,0.562,0.429l2,8.314h9.263L33.601,3.184H25.274z M30.819,29.416
    		h-9.857c-1.057,0-0.497-0.899-0.497-0.899l6.595-12.718c0.622-1.199,1.236-0.006,1.236-0.006l3.262,12.719
    		C31.812,29.503,30.819,29.416,30.819,29.416z M27.405,17.869l-5.301,10.223h7.923L27.405,17.869z"/>
    	<path class="about-path" d="M85.644,33.947c-1.161,8.582-8.684,12.957-17.412,12.957H51.804c-0.401,0-0.611-0.379-0.573-0.662l5.882-43.508
    		c0.054-0.401,0.468-0.663,0.752-0.663h16.428c8.803,0,13.603,4.63,12.456,13.116c-0.483,3.57-2.098,6.586-4.439,8.775
    		C84.95,26.297,86.224,29.656,85.644,33.947z M80.901,23.553c2.406-1.988,4.043-4.816,4.523-8.365
    		c1.045-7.73-3.049-11.791-11.31-11.791H58.349l-5.703,42.183h15.766c8.336,0,14.875-3.999,15.907-11.632
    		c0.567-4.193-0.802-7.31-3.483-9.366C80.267,24.146,80.761,23.668,80.901,23.553z M64.902,27.244h1.272
    		c1.988,0,9.705,0.141,8.904,6.066c-0.79,5.845-6.716,6.068-10.545,6.068h-1.272c-0.284,0-0.627-0.262-0.573-0.662l1.462-10.811
    		C64.188,27.621,64.501,27.244,64.902,27.244z M64.103,38.055h0.609c4.12,0,8.441-0.307,9.041-4.744
    		c0.589-4.354-5.401-4.742-7.758-4.742h-0.609L64.103,38.055z M65.053,21.229l1.461-10.811c0.039-0.284,0.351-0.662,0.752-0.662
    		h1.272c3.916,0,8.248,0.338,7.473,6.067s-5.198,6.067-9.114,6.067h-1.272C65.341,21.891,64.999,21.629,65.053,21.229z
    		 M67.077,20.566c4.033,0,6.995-0.192,7.61-4.743s-2.294-4.743-6.328-4.743H67.75l-1.283,9.486H67.077z"/>
    	<path class="about-path" d="M118.206,1.064c12.683,0,21.215,10.652,19.506,23.291c-1.708,12.637-13.126,23.344-25.811,23.344
    		c-12.683,0-21.26-10.704-19.551-23.344C94.059,11.714,105.525,1.064,118.206,1.064z M112.08,46.374
    		c11.905,0,22.691-10.067,24.307-22.019c1.616-11.95-6.454-21.967-18.36-21.967c-11.908,0-22.738,10.019-24.353,21.967
    		C92.059,36.305,100.174,46.374,112.08,46.374z M116.831,11.239c7.171,0,11.935,5.99,10.972,13.116
    		c-0.963,7.123-7.35,13.169-14.525,13.169c-7.173,0-11.981-6.042-11.018-13.169C103.223,17.226,109.662,11.239,116.831,11.239z
    		 M113.456,36.199c6.391,0,12.15-5.4,13.021-11.844c0.871-6.441-3.431-11.791-9.826-11.791c-6.397,0-12.197,5.354-13.067,11.791
    		C102.713,30.795,107.062,36.199,113.456,36.199z"/>
    	<path class="about-path" d="M177.901,30.715c-1.508,11.153-8.605,16.984-20.023,16.984s-16.938-5.831-15.43-16.984l3.812-28.193
    		c0.054-0.4,0.468-0.662,0.752-0.662h9.963c0.401,0,0.611,0.378,0.573,0.662L154.13,27.8c-0.965,7.134,0.759,8.771,5.252,8.771
    		c4.495,0,6.66-1.637,7.625-8.771l3.417-25.278c0.054-0.4,0.468-0.662,0.752-0.662h9.963c0.401,0,0.611,0.378,0.573,0.662
    		L177.901,30.715z M171.661,3.184L168.333,27.8c-1.013,7.493-3.872,10.095-9.128,10.095c-5.257,0-7.412-2.603-6.399-10.095
    		l3.328-24.616h-8.638l-3.722,27.531c-1.416,10.467,3.444,15.659,14.284,15.659c10.839,0,17.104-5.192,18.519-15.659l3.723-27.531
    		H171.661z"/>
    	<path class="about-path" d="M186.831,2.521c0.055-0.4,0.468-0.662,0.752-0.662h30.736c0.401,0,0.611,0.378,0.573,0.662l-1.182,8.744
    		c-0.054,0.401-0.468,0.662-0.752,0.662h-9.725l-4.639,34.314c-0.054,0.4-0.468,0.662-0.752,0.662h-9.963
    		c-0.401,0-0.611-0.379-0.573-0.662l4.639-34.314h-9.724c-0.401,0-0.611-0.377-0.573-0.662L186.831,2.521z M196.788,10.604
    		c0.284,0,0.627,0.262,0.573,0.662l-4.64,34.313h8.638l4.639-34.313c0.039-0.284,0.351-0.662,0.752-0.662h9.725l1.003-7.42h-29.412
    		l-1.003,7.42H196.788z"/>
    	<!-- <path class="about-path" d="M271.396,45.993c0,0,0.338,0.911-0.737,0.911h-10.705c-0.275,0-0.502-0.18-0.562-0.43l-2-8.314h-15.718l-4.144,8.309
    		c-0.129,0.258-0.406,0.436-0.682,0.436h-10.705c0,0-1.027,0.086-0.492-0.91l23.505-43.72c0.136-0.254,0.42-0.415,0.67-0.415h9.221
    		c0.274,0,0.496,0.184,0.558,0.414L271.396,45.993z M250.097,3.184l-22.793,42.396h9.26l4.144-8.308
    		c0.129-0.259,0.406-0.436,0.682-0.436h16.64c0.267,0,0.5,0.172,0.562,0.429l2,8.314h9.263L258.424,3.184H250.097z M255.642,29.416
    		h-9.857c-1.057,0-0.497-0.899-0.497-0.899l6.595-12.718c0.622-1.199,1.236-0.006,1.236-0.006l3.262,12.719
    		C256.635,29.503,255.642,29.416,255.642,29.416z M252.228,17.869l-5.301,10.223h7.923L252.228,17.869z"/>
    	<path class="about-path" d="M282.389,2.521c0,0,0.25-1.348,1.153-0.511l23.343,21.636l2.956-21.128c0.053-0.378,0.426-0.659,0.752-0.659h9.962
    		c0.401,0,0.611,0.378,0.573,0.662l-5.911,43.721c0,0-0.246,1.346-1.151,0.512L290.614,25.17l-2.849,21.072
    		c-0.054,0.4-0.467,0.662-0.752,0.662h-9.963c-0.401,0-0.611-0.379-0.573-0.662L282.389,2.521z M286.53,45.579l2.948-21.807
    		c0.178-1.316,1.151-0.513,1.151-0.513l23.45,21.584l5.633-41.66h-8.641l-3.059,21.863c-0.184,1.316-1.152,0.509-1.152,0.509
    		l-23.337-21.63l-5.632,41.653H286.53z"/>
    	<path class="about-path" d="M340.855,1.859c12.319,0,21.384,9.399,19.613,22.496c-1.777,13.146-13.33,22.549-25.704,22.549h-12.718
    		c-0.401,0-0.611-0.379-0.573-0.662l5.911-43.721c0.055-0.4,0.468-0.662,0.752-0.662H340.855z M322.888,45.579h12.056
    		c11.686,0,22.523-8.827,24.2-21.224c1.668-12.341-6.834-21.172-18.468-21.172H328.62L322.888,45.579z M333.213,38.001
    		c-0.285,0-0.627-0.261-0.573-0.662l3.503-25.914c0.039-0.284,0.351-0.663,0.752-0.663c11.089,0,13.983,5.737,12.914,13.646
    		C348.74,32.32,344.299,38.001,333.213,38.001z M337.378,12.094l-3.323,24.576c9.943-0.223,13.456-5.064,14.429-12.262
    		C349.462,17.18,347.194,12.316,337.378,12.094z"/>
    	<path class="about-path" d="M403.393,11.266c-0.054,0.401-0.468,0.662-0.752,0.662h-14.388l-0.996,7.367h13.752c0.401,0,0.611,0.377,0.573,0.662
    		l-1.183,8.744c-0.054,0.4-0.468,0.662-0.752,0.662h-13.752l-1.01,7.473h14.388c0.401,0,0.611,0.377,0.573,0.662l-1.183,8.744
    		c-0.055,0.4-0.468,0.662-0.752,0.662h-25.013c-0.401,0-0.611-0.379-0.573-0.662l5.911-43.721c0.054-0.4,0.468-0.662,0.752-0.662
    		h25.013c0.401,0,0.611,0.378,0.573,0.662L403.393,11.266z M379.473,3.184l-5.732,42.396h23.688l1.003-7.419h-14.388
    		c-0.284,0-0.627-0.262-0.573-0.662l1.189-8.797c0.039-0.285,0.352-0.663,0.752-0.663h13.752l1.004-7.419h-13.752
    		c-0.285,0-0.628-0.262-0.573-0.662l1.175-8.691c0.039-0.284,0.352-0.662,0.752-0.662h14.388l1.004-7.42H379.473z"/>
    	<path class="about-path" d="M436.842,24.096l13.81,21.742c0,0,0.64,1.066-0.669,1.066h-12.878c-0.215,0-0.409-0.126-0.495-0.268l-8.021-13.17
    		l-11.583,13.17c-0.152,0.173-0.392,0.268-0.568,0.268h-12.348c0,0-1.31-0.014-0.387-1.059l19.175-21.75L409.51,2.925
    		c0,0-0.639-1.065,0.67-1.065h12.348c0.2,0,0.381,0.094,0.483,0.249l8.156,12.282l11.477-12.282
    		c0.146-0.157,0.354-0.249,0.551-0.249h12.878c0,0,1.328,0.045,0.374,1.073L436.842,24.096z M443.334,3.184l-11.85,12.682
    		c-0.564,0.605-0.949,0.129-1.034,0l-8.421-12.682h-10.687l12.945,20.504c0.145,0.229,0.105,0.562-0.103,0.799L405.59,45.579h10.693
    		l11.977-13.617c0.65-0.739,1.032-0.05,1.062,0l8.294,13.617h11.198l-13.392-21.085c-0.135-0.213-0.112-0.568,0.116-0.814
    		l18.985-20.496H443.334z"/>
    	<path class="about-path" d="M477.893,1.859c10.853,0.254,14.602,7.067,13.636,14.124c-1.87,13.673-16.708,14.608-22.866,14.698l-2.104,15.561
    		c-0.054,0.4-0.468,0.662-0.752,0.662h-9.963c-0.4,0-0.611-0.379-0.572-0.662l5.911-43.721c0.054-0.4,0.468-0.662,0.752-0.662
    		H477.893z M456.685,45.579h8.638l2.104-15.554c0.044-0.322,0.369-0.66,0.747-0.662c6.104-0.044,20.293-0.68,22.031-13.383
    		c0.875-6.396-2.348-12.559-12.506-12.797h-15.281L456.685,45.579z M468.5,22.076l1.569-11.605c0.039-0.284,0.352-0.662,0.752-0.662
    		c5.693,0,10.934,0.999,10.172,6.494c-0.812,5.85-7.202,6.334-11.905,6.436C468.699,22.747,468.452,22.432,468.5,22.076z
    		 M479.669,16.298c0.555-4.005-2.91-5.077-8.365-5.159l-1.387,10.258C474.744,21.242,479.086,20.5,479.669,16.298z"/>
    	<path class="about-path" d="M524.338,11.266c-0.055,0.401-0.468,0.662-0.752,0.662h-14.388l-0.996,7.367h13.752c0.4,0,0.611,0.377,0.572,0.662
    		l-1.182,8.744c-0.055,0.4-0.468,0.662-0.752,0.662h-13.752l-1.011,7.473h14.388c0.401,0,0.611,0.377,0.573,0.662l-1.183,8.744
    		c-0.054,0.4-0.467,0.662-0.752,0.662h-25.013c-0.401,0-0.611-0.379-0.573-0.662l5.911-43.721c0.055-0.4,0.468-0.662,0.752-0.662
    		h25.014c0.4,0,0.611,0.378,0.572,0.662L524.338,11.266z M500.417,3.184l-5.731,42.396h23.688l1.003-7.419h-14.388
    		c-0.285,0-0.628-0.262-0.573-0.662l1.189-8.797c0.038-0.285,0.351-0.663,0.752-0.663h13.752l1.003-7.419H507.36
    		c-0.284,0-0.627-0.262-0.573-0.662l1.176-8.691c0.038-0.284,0.351-0.662,0.752-0.662h14.388l1.003-7.42H500.417z"/>
    	<path class="about-path" d="M548.063,1.859c10.853,0.254,14.602,7.067,13.636,14.124c-0.897,6.561-4.88,10.255-9.392,12.261l9.216,17.633
    		c0,0,0.589,1.027-0.692,1.027h-10.97c-0.225,0-0.423-0.125-0.514-0.3l-8.313-15.993c-0.872,0.044-1.623,0.062-2.201,0.07
    		l-2.104,15.561c-0.054,0.4-0.468,0.662-0.752,0.662h-9.963c-0.4,0-0.611-0.379-0.572-0.662l5.911-43.721
    		c0.054-0.4,0.468-0.662,0.752-0.662H548.063z M526.855,45.579h8.638l2.104-15.554c0.044-0.322,0.369-0.66,0.747-0.662
    		c0.888-0.006,1.972-0.025,3.178-0.096c0.203-0.012,0.446,0.094,0.553,0.299l8.324,16.013h9.383l-9.021-17.26
    		c-0.317-0.608,0.247-0.903,0.43-0.976c4.475-1.775,8.317-5.027,9.185-11.363c0.875-6.396-2.348-12.559-12.506-12.797h-15.281
    		L526.855,45.579z M538.671,22.076l1.569-11.605c0.039-0.284,0.352-0.662,0.752-0.662c5.693,0,10.934,0.999,10.172,6.494
    		c-0.812,5.85-7.202,6.334-11.905,6.436C538.87,22.747,538.623,22.432,538.671,22.076z M549.84,16.298
    		c0.555-4.005-2.91-5.077-8.364-5.159l-1.388,10.258C544.915,21.242,549.257,20.5,549.84,16.298z"/>
    	<path class="about-path" d="M574.968,46.242c-0.054,0.4-0.468,0.662-0.752,0.662h-9.963c-0.4,0-0.611-0.379-0.572-0.662l5.911-43.721
    		c0.054-0.4,0.468-0.662,0.752-0.662h9.963c0.4,0,0.611,0.378,0.572,0.662L574.968,46.242z M570.827,3.184l-5.732,42.396h8.638
    		l5.732-42.396H570.827z"/>
    	<path class="about-path" d="M612.423,11.266c-0.055,0.401-0.468,0.662-0.752,0.662h-14.388l-0.996,7.367h13.752c0.4,0,0.611,0.377,0.572,0.662
    		l-1.182,8.744c-0.055,0.4-0.468,0.662-0.752,0.662h-13.752l-1.011,7.473h14.388c0.401,0,0.611,0.377,0.573,0.662l-1.183,8.744
    		c-0.054,0.4-0.467,0.662-0.752,0.662h-25.013c-0.401,0-0.611-0.379-0.573-0.662l5.911-43.721c0.055-0.4,0.468-0.662,0.752-0.662
    		h25.014c0.4,0,0.611,0.378,0.572,0.662L612.423,11.266z M588.502,3.184l-5.731,42.396h23.688l1.003-7.419h-14.388
    		c-0.285,0-0.628-0.262-0.573-0.662l1.189-8.797c0.038-0.285,0.351-0.663,0.752-0.663h13.752l1.003-7.419h-13.752
    		c-0.284,0-0.627-0.262-0.573-0.662l1.176-8.691c0.038-0.284,0.351-0.662,0.752-0.662h14.388l1.003-7.42H588.502z"/>
    	<path class="about-path" d="M619.994,2.521c0,0,0.249-1.348,1.152-0.511l23.343,21.636l2.956-21.128c0.053-0.378,0.425-0.659,0.751-0.659h9.963
    		c0.401,0,0.611,0.378,0.573,0.662l-5.911,43.721c0,0-0.246,1.346-1.151,0.512L628.219,25.17l-2.849,21.072
    		c-0.054,0.4-0.468,0.662-0.752,0.662h-9.963c-0.4,0-0.611-0.379-0.572-0.662L619.994,2.521z M624.135,45.579l2.948-21.807
    		c0.179-1.316,1.151-0.513,1.151-0.513l23.451,21.584l5.632-41.66h-8.641l-3.059,21.863c-0.185,1.316-1.152,0.509-1.152,0.509
    		l-23.337-21.63l-5.632,41.653H624.135z"/>
    	<path class="about-path" d="M682.623,47.699c-12.681,0-22.955-10.32-21.209-23.238c1.753-12.965,14.774-23.396,27.515-23.396
    		c9.582,0,12.562,2.146,12.681,2.232c0.206,0.154,0.271,0.443,0.184,0.689l-3.445,9.805c-0.022,0.062-0.279,0.881-1.024,0.441
    		c0,0-3.42-2.039-8.363-2.039c-9.643,0-14.652,6.662-15.396,12.162c-0.751,5.555,2.458,12.215,12.1,12.215
    		c4.943,0,8.915-2.039,8.915-2.039c0.061-0.031,0.832-0.454,0.904,0.441l0.795,9.805c0.021,0.271-0.152,0.547-0.362,0.684
    		C695.726,45.578,692.171,47.699,682.623,47.699z M694.218,36.074c-1.49,0.623-4.831,1.82-8.732,1.82
    		c-10.39,0-14.086-7.33-13.246-13.539c0.833-6.158,6.512-13.487,16.9-13.487c3.888,0,6.838,1.161,8.239,1.821l2.986-8.498
    		c-0.954-0.488-4.217-1.803-11.616-1.803c-12.062,0-24.367,9.919-26.01,22.072c-1.636,12.096,8.049,21.913,20.062,21.913
    		c7.367,0,10.965-1.29,12.104-1.803L694.218,36.074z"/>
    	<path class="about-path" d="M732.571,11.266c-0.055,0.401-0.468,0.662-0.752,0.662h-14.388l-0.996,7.367h13.752c0.4,0,0.611,0.377,0.572,0.662
    		l-1.182,8.744c-0.055,0.4-0.468,0.662-0.752,0.662h-13.752l-1.011,7.473h14.388c0.401,0,0.611,0.377,0.573,0.662l-1.183,8.744
    		c-0.054,0.4-0.467,0.662-0.752,0.662h-25.013c-0.401,0-0.611-0.379-0.573-0.662l5.911-43.721c0.055-0.4,0.468-0.662,0.752-0.662
    		h25.014c0.4,0,0.611,0.378,0.572,0.662L732.571,11.266z M708.65,3.184l-5.731,42.396h23.688l1.003-7.419h-14.388
    		c-0.285,0-0.628-0.262-0.573-0.662l1.189-8.797c0.038-0.285,0.351-0.663,0.752-0.663h13.752l1.003-7.419h-13.752
    		c-0.284,0-0.627-0.262-0.573-0.662l1.176-8.691c0.038-0.284,0.351-0.662,0.752-0.662h14.388l1.003-7.42H708.65z"/> -->
    </g>
    </svg>

    <div class="about-container">

      <div class="lefty">
        <p>
          Born and raised in Sydney, Australia, I'm a web developer with a passion
          for intuitive design and front-end development.
          <br><br>
          Outside of work I love listening to podcasts from RadioLab, This
          American Life and Syntax as well as riding my motorbike around the
          streets of Sydney.
          <br><br>
          My background is in the fast-paced agency world as a
          developer and project manager. I've also worked as a teachers
          assistant for General Assembly's Front End Web Development course, and as
					a freelance developer.
          <br><br>
          I'm at my best when I'm working on the front-end, but I'm also
          comfortable working with Ruby on Rails, PHP/Laravel as well as
          PHP/Wordpress. I absolutely love working with VueJS. It's my go to
          framework for the bulk of my professional projects as well as personal
          ones.
        </p>

      </div>

      <div class="righty">

        <div id="myCanvasContainer" style="float: right">
          <canvas width="500" height="400" id="myCanvas" style="width: 100% !important">
            <!-- <p>Anything in here will be replaced on browsers that support the canvas element</p> -->
            <ul>
              <li><a target="_blank" aria-hidden=”false class="skill">HTML/CSS:<br> Less, Sass</a></li>
              <li><a target="_blank" aria-hidden=”false class="skill">Javascript: <br>Vanilla JS, <br>ES6, JQuery</a></li>
              <li><a target="_blank" aria-hidden=”false class="skill">VueJS:<br> Vue Router, Vuex</a></li>
              <li><a target="_blank" aria-hidden=”false class="skill">Firebase Suite</a></li>
              <li><a target="_blank" aria-hidden=”false class="skill">Wordpress</a></li>
              <li><a target="_blank" aria-hidden=”false class="skill">Photoshop</a></li>
              <li><a target="_blank" aria-hidden=”false class="skill">Ruby on Rails</a></li>
              <li><a target="_blank" aria-hidden=”false class="skill">Git</a></li>
              <li><a target="_blank" aria-hidden=”false class="skill">Yarn</a></li>
              <li><a target="_blank" aria-hidden=”false class="skill">NPM</a></li>
              <li><a target="_blank" aria-hidden=”false class="skill">MAMP</a></li>
              <li><a target="_blank" aria-hidden=”false class="skill">RESTful APIs</a></li>
              <li><a target="_blank" aria-hidden=”false class="skill">Sketch</a></li>
              <li><a target="_blank" aria-hidden=”false class="skill">Webpack</a></li>
            </ul>
          </canvas>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
let controller = new ScrollMagic.Controller()

export default {
  mounted() {
    TagCanvas.textColour = '#000';
    TagCanvas.textFont = 'Crimson Text';
    TagCanvas.wheelZoom = false;
    TagCanvas.outlineColour = '#ffffff00';
    TagCanvas.activeCursor = 'auto';
    TagCanvas.initial = [0.1,-0.1];
    TagCanvas.noSelect = true;
    TagCanvas.Start('myCanvas');

		let aboutTween = TweenMax.to('.about-outer', 1, { opacity:1  });
    let scene = new ScrollMagic.Scene({
      triggerElement: ".about-outer",
      triggerHook: "onEnter",
			triggerHook: "0.8",
			reverse: false
    })
    .setTween(aboutTween)
		.addTo(controller);
  }
}
</script>

<style lang="css" scoped>
  .skill {
    color: black;
  }
  .gold-text {
    color: gold;
  }

  .about-outer {
    margin-top: 70px;
    opacity: 0;
		padding-top: 20px;
  }

  .about-container {
    margin: 0 auto;
    padding-top: 60px;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
  }

  .lefty {
    width: 48%;
  }
  .righty {
    width: 50%;
  }

  #Layer_3 {
    display: block;
    max-width: 80%;
  }

  .about-path {
    fill:none;
    stroke:#A8A030;
  }

	/* MOBILE RESPONSIVE */
	@media only screen and (max-width: 700px) {
		.about-container {
			display: block;
			padding-top: 9px;
		}

		.lefty {
			width: 100%;
		}

		.righty {
			width: 100%;
			text-align: center;
			margin-top: 50px;
		}

		#myCanvasContainer {
			float: none !important;
		}

    #Layer_3 {
      max-width: 80% !important;
    }
	}

</style>



// WEBPACK FOOTER //
// About.vue?516c0ac7